import { TopicBoxVMConfig, TopicBoxVMTheme } from 'components/topic/box/box';
import { wccModules } from 'enums/wccModules';
import { Func } from 'interfaces/func';
import { inject, injectable } from 'inversify';
import { SubscribableOrNullableValue } from 'knockout';
import { SimpleTopic } from 'models/simpleTopic';
import TopicsSliderItem from './item';
import './topic.html';
import './topic.scss';

components.preload('topic-box');

export class TopicsSliderTopic extends TopicsSliderItem {
    constructor(public topic: SimpleTopic) {
        super();
    }
}

export interface TopicsSliderTopicVMConfig {
    topicItem: TopicsSliderTopic
    theme?: SubscribableOrNullableValue<TopicsSliderTopicVMTheme>

    activate?: Action<[topicItem: TopicsSliderTopic]> | Func<Promise<void>, [topicItem: TopicsSliderTopic]>
}

export type TopicsSliderTopicVMTheme = TopicBoxVMTheme;

@injectable()
export default class TopicsSliderTopicVM {
    topicBoxConfig: TopicBoxVMConfig

    constructor(
        @inject(wccModules.componentConfig) config: TopicsSliderTopicVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        const topicItem = config.topicItem;
        const theme = ko.flattenComputed(config.theme, 'classic');

        const isSelected = topicItem.isSelected;
        const isNotSelected = isSelected.not();

        const isActive = topicItem.isActive;
        const isInactive = isActive.not();

        this.topicBoxConfig = {
            topic: topicItem.topic,
            theme: theme,
            showExpander: true,
            canActivate: isInactive,

            activate: config.activate ? () => config.activate?.(topicItem) : undefined
        }

        ko.applyBindingsToNode(info.element, {
            'css': {
                'task__topics-slider__topic': true,
                'task__topics-slider__topic--theme-small': theme.is('small', 'small-rounded'),
                'task__topics-slider__topic--theme-rounded': theme.is('small-rounded'),
                'task__topics-slider__topic--selected': isSelected,
                'task__topics-slider__topic--not-selected': isNotSelected,
                'task__topics-slider__topic--highlighted': topicItem.isHighlighted
            }
        });
    }
}